<div class="info-header" [ngClass]="{ expanded: expanded }">
  <div class="info-header__left">
    <button (click)="accordion()" class="info-header__left__button">
      <span class="material-icons">keyboard_arrow_down</span>
    </button>
    <div style="display: flex; flex-direction: column">
      <span class="project-name" (click)="accordion()">
        <span *ngIf="isRush" class="rush-badge">
            <span class="material-icons rush-badge__icon">schedule</span>
            Rush Request
          </span>
          {{"Project ID: " + data.projectOrderId}}
        </span>
      <div class="invitation-dates-container">
        <span
          *ngIf="
            (type === 'invitations' || type === 'proposals') &&
            invitationCreatedDate
          "
          class="invitation-dates"
          >Invitation Received:
          {{
            invitationCreatedDate | date : "MM/dd/yyyy hh:mm a" : locale
          }}</span
        >
        <span
          *ngIf="type === 'active' && projectActiveDate"
          class="invitation-dates"
          >Activation Date:
          {{ projectActiveDate | date : "MM/dd/yyyy hh:mm a" : locale }}</span
        >
        <span *ngIf="invitationUpdatedDate" class="invitation-dates">
          {{
            type === "proposals" || type === "active"
              ? "Updated:"
              : "Invitation Updated:"
          }}
          {{
            invitationUpdatedDate | date : "MM/dd/yyyy hh:mm a" : locale
          }}</span
        >
      </div>
    </div>
  </div>
  <div class="info-header__right">
    <a
      class="info-header__right__overview"
      [routerLink]="['/', 'project-overview', data.projectId]"
      >Project Overview</a
    >
    <button
      class="info-header__right__request"
      (click)="toggleSpecialRequestModal()"
      *ngIf="data.specialQuoteRequirements"
    >
      <span class="material-icons">assignment</span>Project Requirements
    </button>
    <button
      *ngIf="type === 'invitations' && showSubmitBid"
      class="info-header__right__atp"
      (click)="toggleSubmitAllBidsModal()"
      [disabled]="!enableSubmitAllBids"
    >
      <span class="material-icons">gavel</span>Submit All Bids
    </button>
    <button
      *ngIf="type === 'invitations' && showAccept"
      class="info-header__right__atp"
      (click)="toggleAcceptAllOfferedProposalModal()"
    >
      <span class="material-icons">fact_check</span>Accept All Offers
    </button>
    <button
      *ngIf="type === 'proposals' && showAtp"
      class="info-header__right__atp"
      (click)="generateATP()"
    >
      <span class="material-icons">login</span>Sign Award
    </button>
  </div>
</div>

<signatp-dialog
  [atpDocumentPath]="atpDocumentPath"
  [active]="signAtpActive"
  [address]="address"
  (modalClosed)="toggleATPModal()"
  [ngClass]="{ 'documents-dialog--active': signAtpActive }"
  [modalHeaderTitle]="childModalHeaderTitle"
  [modalBody]="childModalBody"
  (signedAtpEvent)="signATP($event)"
  (declineAtpEvent)="declineATP($event)"
/>

<allbids-dialog
  [data]="data"
  [active]="allBidsActive"
  [documents]="documents"
  [address]="address"
  [numberOfBids]="numberOfBids"
  (modalClosed)="toggleSubmitAllBidsModal()"
  [ngClass]="{ 'documents-dialog--active': allBidsActive }"
/>

<project-special-request-dialog
  [active]="specialRequestToggle"
  [projectName]="'Project ID: ' + data.projectOrderId"
  [specialQuoteRequirements]="data.specialQuoteRequirements"
  (closeDialog)="toggleSpecialRequestModal()"
/>

<accept-offered-proposal-dialog
  [active]="acceptAllOffersActive"
  [data]="data"
  [multiple]="true"
  (modalClosed)="toggleAcceptAllOfferedProposalModal()"
  [ngClass]="{ 'documents-dialog--active': acceptAllOffersActive }"
/>
